<template>
    <a-modal
        :visible="visible"
        :title="state.title"
        @cancel="handleModalCancel"
        width="70%"
        :destroy-on-close="true"
        :footer="null">
    
        <AForm
            ref="formRef"
            class="myform"
            :model="form"
            :rules="state.rules"
            @finish="handleOk"
            :wrapper-col="{ span: 14 }"
            :scroll-to-first-error="true">

            <!-- new phone -->
            <AFormItem
                label="Nomor Telepon Baru"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="new_phone"
                has-feedback>
                <AInput
                    addon-before="+62"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    pattern="^[1-9][0-9]*$"
                    oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value=''"
                    placeholder="Ex : 81xxxxxxxxx"
                    v-model:value="form.new_phone"
                    :disabled="item.readOnly"
                    min="0"
                    maxlength="13" />
            </AFormItem>

            <ARow
                v-if="!form.readOnly"
                class="form-row"
                type="flex"
                justify="end">
                <ACol>
                    <AFormItem>
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="form.busy"
                            :disabled="form.busy">{{
                            !form.id ? 'Simpan' : 'Perbarui'
                        }}</a-button>
                    </AFormItem>
                </ACol>
            </ARow>
        </AForm>

        <div v-if="state.errors">
            <ASpace>
                <AAlert
                    v-for="(item, index) in state.errors"
                    type="error"
                    :key="index"
                    :message="item"
                    banner
                    closable
                    @close="state.errors = []" />
            </ASpace>
        </div>
    </a-modal>
</template>
<script>
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
} from 'vue'
import Form from 'vform'
import { Modal, message } from 'ant-design-vue'
import {
    ROLE_ADMIN_BK,
    hasRoles,
} from '@/helpers'

export default defineComponent({
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
                readOnly: false,
            }),
        },
    },
    emits: ['update:visible'],
    setup(props, { emit }) {
        const form = reactive(new Form({
            code: props.item.code,
            program_id: props.item.program_id,
            new_phone: null,
        }))

        const formRef = ref();

        const state = reactive({
            title: 'Lihat List Toko',
            endpoint: `/api/loyalty-program-stores/update`,
            data: [],
            page: 1,
            per_page: 1,
            total: 0,
            loading: false,
            rules: {
                new_phone: [
                    {
                        required: true,
                        message: 'Nomor Telepon tidak boleh kosong!',
                    },
                    {
                        max: 12,
                        min: 0,
                        message: 'Maximal nomor telepon 12 angka!',
                    },
                    {
                        pattern: /^[1-9][0-9]*$/,
                        message: "Masukkan nomor telepon aktif tanpa angka '0' di awal dan hanya boleh memuat angka!",
                    },
                ],
            },
            errors: [],
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const handleOk = async () => {
            // validation form
            await formRef.value.validate()
                .catch(() => {});

            form.post(state.endpoint)
                .then(({ data }) => {
                    message.success(data.message)

                    handleModalCancel()
                    emit('success', data)
                })
                .catch(({ response: { data, status } }) => {
                    if (data.errors) {
                        state.errors = data.errors
                    }

                    if (status == 422 && data.status == 'failed') {
                        message.info(data.message)
                    }
                })
        }

        // handle func vue
        onMounted(() => {
            if (!form.code) {
                form.reset()
            } else {
                form.readOnly = props.item.readOnly
            }

            if (!props.item.readOnly) {
                state.title = `${!form.code ? 'Tambah' : 'Edit'} List Toko`
            }
        })

        return {
            formRef,
            handleOk,
            form,
            state,
            handleModalCancel,
            // only variable role
            hasRoles,
            ROLE_ADMIN_BK,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
